import { Trans, useTranslation } from "react-i18next";

import {
  HistoryEntryCard,
  type EntityHistoryEntry,
} from "@/components/ui/v2/history";
import type { VacancyOverride } from "@/features/segments/types";

type OverridesChangedChanges = {
  added?: VacancyOverride[];
  removed?: VacancyOverride[];
  switched?: VacancyOverride[];
};

export function OverridesChangedHistoryItem({
  entry,
}: {
  entry: EntityHistoryEntry;
}) {
  const { t } = useTranslation();
  const changes = entry.changes as OverridesChangedChanges | undefined;
  const summary = [
    { key: "added", count: changes?.added?.length ?? 0 },
    { key: "removed", count: changes?.removed?.length ?? 0 },
    { key: "switched", count: changes?.switched?.length ?? 0 },
  ]
    .filter(({ count }) => count > 0)
    .map(({ key, count }) => t(`history.count.overrides.${key}`, { count }))
    .join(", ");

  return (
    <HistoryEntryCard
      occurredAt={entry.occurredAt}
      description={
        <Trans
          i18nKey="history.line1.overridesChanged"
          values={{ actor: t("history.actor.system") }}
          components={{ b: <strong className="font-semibold" /> }}
        />
      }
      count={summary}
    />
  );
}
